import * as yup from "yup";
import { enMessages } from "../../../messages/en-US";

interface ValidationSchemaParams {
    routeOrders: Array<any>;
    localizationService: any;
    rfids: Array<any>;
}

export default function PointValidationSchema({ routeOrders, localizationService, rfids}: ValidationSchemaParams) {
    return yup.object().shape({
    consumableId: yup.string().required(`${localizationService.toLanguageString('custom.fieldIsRequired', enMessages.custom.fieldIsRequired)}`).nullable(),
    routeOrder: yup
        .string()
        .required(`${localizationService.toLanguageString('custom.fieldIsRequired', enMessages.custom.fieldIsRequired)}`)
        .test(
            'unique-route-order',
            `${localizationService.toLanguageString('custom.routeOrderUnique', enMessages.custom.routeOrderUnique)}`,
            function(value) {
                if (!value) return true;
                const numValue = Number(value);
                return !routeOrders.some(routeOrder => routeOrder === numValue);
            }
        ),
    machineId: yup.string().required(`${localizationService.toLanguageString('custom.fieldIsRequired', enMessages.custom.fieldIsRequired)}`).nullable(),
    areaId: yup.string().required(`${localizationService.toLanguageString('custom.fieldIsRequired', enMessages.custom.fieldIsRequired)}`).nullable(),
    volumeRequirement: yup.string()
        .matches(/^(Purge|purge|P|p|-1|\d+([\.]\d+)?)$/, 
            `${localizationService.toLanguageString('custom.fieldIsRequired', enMessages.custom.fieldIsRequired)}`)
        .test(
            'is-valid-volume',
            `${localizationService.toLanguageString('custom.volumeRequirementValidation', enMessages.custom.volumeRequirementValidation)}`,
            function(value) {
                if (!value) return false;
                // Allow Purge variations and -1
                if (/^(Purge|purge|P|p|-1)$/.test(value)) return true;
                // For numeric values, ensure greater than 0
                const numValue = parseFloat(value);
                return !isNaN(numValue) && numValue > 0;
            }
        )
        .required(`${localizationService.toLanguageString('custom.volumeRequirementValidation', enMessages.custom.volumeRequirementValidation)}`),
    name: yup.string().min(2).max(48).required(`${localizationService.toLanguageString('custom.fieldIsRequired', enMessages.custom.fieldIsRequired)}`),
    //@ts-ignore
    currentTagRfid: yup.string().max(24).optional().test(
        'unique-rfid',
        `${localizationService.toLanguageString('custom.rfidUnique', enMessages.custom.rfidUnique)}`,
        function(value) {
            return !rfids.includes(value);
        }
    ),
})};
